/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "sort--sprite",
  "use": "sort--sprite-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"sort--sprite\"><path opacity=\".5\" d=\"M3.343 13.636V1.233l2.067 2.18a.333.333 0 0 0 .489 0 .375.375 0 0 0 0-.512L3.244.102a.34.34 0 0 0-.486 0L.101 2.901a.375.375 0 0 0 0 .512.33.33 0 0 0 .486 0l2.067-2.18v12.403c0 .201.155.364.346.364a.358.358 0 0 0 .343-.364Zm7.411.257a.334.334 0 0 0 .49 0l2.655-2.797a.375.375 0 0 0 0-.512.33.33 0 0 0-.486 0l-2.069 2.178V.364A.355.355 0 0 0 11 0a.355.355 0 0 0-.346.364v12.398l-2.066-2.178a.33.33 0 0 0-.486 0 .375.375 0 0 0 0 .512l2.653 2.797Z\" fill=\"#232323\" /></symbol>"
});
sprite.add(symbol);
var viewBoxValues = symbol.viewBox ? symbol.viewBox.split(' ') : []

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox,
      width: viewBoxValues[2],
      height: viewBoxValues[3]
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.width = viewBoxValues[2];
SvgSpriteIcon.height = viewBoxValues[3];
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
